import React from "react";
import { Layout } from "@/components/Layout";
import { PageHeader } from "@/components/PageHeader";
import { Button } from "@/components/ui/button";
import { useApp } from "@/context/AppContext";
import { Target, Wallet, CalendarCheck, Sparkles } from "lucide-react";

const PILLARS = [
  { icon: Target, title: "Goals", desc: "Set lifestyle intentions and let MOVA break them into effortless steps." },
  { icon: Wallet, title: "Budget", desc: "Track spending across travel, fashion and self-care in one refined view." },
  { icon: CalendarCheck, title: "Everyday", desc: "Reservations, reminders and errands — quietly handled for you." },
];

const Lifestyle = () => {
  const { setPlannerOpen } = useApp();
  return (
    <Layout>
      <PageHeader
        eyebrow="Lifestyle"
        title="Manage your goals, budget & everyday."
        subtitle="One intelligent concierge for the way you want to live."
        image="https://images.pexels.com/photos/7902912/pexels-photo-7902912.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=1600"
      />

      <section className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16" data-testid="lifestyle-pillars">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {PILLARS.map((p) => (
            <div key={p.title} className="rounded-2xl border border-white/10 bg-[#101017] p-8 hover:border-amber-400/40 transition-colors duration-500">
              <div className="w-12 h-12 rounded-full gold-border flex items-center justify-center text-champagne mb-5">
                <p.icon size={20} />
              </div>
              <h3 className="font-serif text-2xl text-white">{p.title}</h3>
              <p className="text-slate-400 mt-3 leading-relaxed">{p.desc}</p>
            </div>
          ))}
        </div>

        <div className="mt-10 relative rounded-3xl overflow-hidden gold-border grain p-10 sm:p-14 bg-gradient-to-br from-[#16160f] to-[#0b0b10] text-center">
          <Sparkles className="mx-auto text-champagne mb-5" size={28} />
          <h2 className="font-serif text-3xl sm:text-4xl text-champagne">Design your ideal week.</h2>
          <p className="text-slate-300 mt-4 max-w-xl mx-auto">Tell our AI concierge your focus, budget and pace — receive a tailored plan in seconds.</p>
          <Button onClick={() => setPlannerOpen(true)} data-testid="lifestyle-planner-btn" className="mt-8 rounded-full h-12 px-8 bg-gradient-to-r from-[#F3E5AB] to-[#D4AF37] text-[#1a1a12] font-medium hover:opacity-90">
            Start Planning
          </Button>
        </div>
      </section>
    </Layout>
  );
};

export default Lifestyle;
